<template>
	<div class='knd-main'>
		<div class='bg' ref='bgbubbles' >
			<canvas id="canvas"></canvas>
			<div id="blob" ref='blob'></div>
			<svg id="svg" width='0' height='0'>
			<defs>
				<filter id="colorChange">
					<feColorMatrix
						type = "matrix"
						values="0.93     0     0     0     0
										0     0.22     0     0     0
										0     0     0.94     0     0
										0     0     0     1     0 "/>
				</filter>
			</defs>
				</svg>
							
			<svg width="0" height="0" >
			<defs>
				<filter id="colorRight">
				<feColorMatrix
					type = "matrix"
					values="0.28     0     0     0     0
					0     0.68     0     0     0
					0     0     0.52     0     0
					0     0     0     1     0 "/>
				</filter>
			</defs>
			</svg>
			
		</div>
			<!-- <div id="gooey" class='gooey' ref='gooey'></div> -->
		<div class='knd-loader' v-if="loading">
			Laden
		</div>

		<div class='knd-story' v-if="!loading" >
			<swiper
				:slidesPerView="1"
				:spaceBetween="30"
				:centeredSlides="false" 
				:grabCursor="true"
				:autoHeight="true"
				:style="{'--swiper-navigation-color': '#07034A','--swiper-pagination-color': '#07034A'}" 
				@swiper="onSwiper"
				@slideChange="onSlideChange"
				:lazy="true" 
				class='knd-swiper'
			>

				<swiper-slide 
				class='knd-article__slide'
				>
					<Landing />
				</swiper-slide>

				<swiper-slide 
					class='knd-article__slide'
					v-for="(question, index) in questions" 
					:class="{'knd-slide__even': index % 2 === 0}"
					:key="index +'-question'"
				>
					<Quiz :question="questions[index]" />
				</swiper-slide>

				<swiper-slide 
				class='knd-article__slide'
				>
					<Eindscherm  />
				</swiper-slide>

			</swiper>


		</div>
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import SwiperCore, { Lazy, Pagination } from 'swiper';

	SwiperCore.use([Pagination, Lazy]);

	import "swiper/swiper-bundle.min.css";
	import 'swiper/components/lazy/lazy.min.css'


	import './scss/index.scss'
	import Landing from '@/components/landing';
	import Quiz from '@/components/quiz';
	import Eindscherm from '@/components/eindscherm';

	import Bubbles from '@/components/background/bubbles.js';
	import Blob from '@/components/background/blob.js';
	// import Gooey from '@/components/background/gooey.js';

export default {
	name: 'App',
	components:{
		Landing, 
		Quiz, 
		Eindscherm,
		Swiper,
		SwiperSlide,
	},
	data: function() {
		return {
			loading: true,
			max: 0,
			height: 0
		}
	},
	watch: {
		'$store.state.currentIndex': function() {
			this.swiper.allowSlideNext = true;
			this.swiper.slideNext();
			window.scrollTo({top: 0});
			this.swiper.allowSlideNext = false;
			this.max = Math.max(this.max, this.swiper.activeIndex);
		}
	},

	computed: {
		currentPage() {
			return this.$store.getters.currentPage;
		},

		questions() {
			return this.$store.getters.vragen;
		},

		currentQuestion() {
			return this.$store.getters.currentQuestion;
		}		
	},
	mounted: function() {
		this.updateHeight();

			window.addEventListener('resize', this.debounce(() => this.updateHeight(),
			200, false), false);

		this.$store.dispatch('loadData')
		.then(() => {
			this.loading = false;
		});

		let bubblesBg = new Bubbles();
		let blob = new Blob(this.$refs.blob);

		// let gooey = new Gooey(this.$refs.gooey);
	},

	methods: {
		debounce(func, wait, immediate){
			var timeout;
			return () => {
				const context = this, args = arguments;
				const later = function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				const callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},

		updateHeight() {
			this.height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;
		},

		nextSlide() {
			
		},

		onSwiper(swiper) {
			this.swiper = swiper;
			this.swiper.allowSlideNext = false;
			this.swiper.allowSlidePrev = false;

			this.$store.dispatch('addSwiper', swiper)
		},
		onSlideChange() {
			// if(this.max > this.swiper.activeIndex) {
			// 	this.swiper.allowSlideNext = true;
			// } else {
			// 	this.swiper.allowSlideNext = false;
			// }
		},

		afterInit() {

		}
	}
}
</script>